import { ApolloQueryResult } from "@apollo/client";
import { GetPositionDetailsQuery } from "#graphql/supergraphTypes";
import { PositionProps } from "../index";
import { PositionRowItem } from "../types";

/**
 * Perform the response manipulation and return the required parameters for the ag-grid
 * @param positionDetails received from the API response
 * @param props PositionProps received from payment details component
 * @returns PositionRowItem list
 */
const prepareDisplayItem = (
  positionDetails: ApolloQueryResult<GetPositionDetailsQuery>,
  props: PositionProps,
): PositionRowItem[] => {
  const positionPayments = positionDetails.data?.paymentBatch?.payments ?? [];
  return props.payments.map((payment) => {
    const positionPayment = positionPayments.find(
      (paymentResponse) => paymentResponse.objectId === payment.objectId,
    );

    const paymentPosition = positionPayment?.position;

    return {
      id: payment.objectId,
      paymentId: positionPayment?.id,
      payee: paymentPosition?.account?.name,
      paymentInstructions: positionPayment?.paymentPref?.bankInfoRedacted,
      method: payment.method,
      amount: payment.amount,
      hostName: props.hostName,
      positionId: paymentPosition?.id,
      accountId: paymentPosition?.account?.id,
      status: positionPayment?.status ?? payment.status,
      referenceNumber: positionPayment?.referenceNumber,
      failedPaymentDetails: positionPayment
        ? {
            returnCode: positionPayment.returnCode,
            returnReason: positionPayment.returnReason,
            failureReason: positionPayment.failureReason,
            failedAt: positionPayment.failedAt,
          }
        : undefined,
    };
  });
};
export const positionsTableUtils = {
  prepareDisplayItem,
};
